


















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Executor extends Vue {
  @Prop() public methods!: string[];
  @Prop() public label!: string;

  get selected() {
    return this.selectedMethod;
  }

  set selected(value) {
    this.$emit('selected', value);
  }

  private selectedMethod = null;

}
